import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "mb-3 error__message-container"
};
const _hoisted_2 = { class: "row align-middle mt-3" };
const _hoisted_3 = { class: "col-sm-7 my-auto align-middle pr-0 d-flex justify-content-center justify-content-sm-start mb-3 mb-sm-2" };
const _hoisted_4 = { class: "col-sm-5 col-12 text-end pl-0" };
const _hoisted_5 = {
    key: 0,
    class: "mb-3 error__message-container"
};
const _hoisted_6 = { class: "row align-middle mt-3" };
const _hoisted_7 = { class: "col-sm-7 my-auto align-middle pr-0 d-flex justify-content-center justify-content-sm-start mb-3 mb-sm-2" };
const _hoisted_8 = { key: 0 };
const _hoisted_9 = { class: "col-sm-5 col-12 text-end pl-0" };
const _hoisted_10 = /*#__PURE__*/ _createElementVNode("div", {
    class: "mb-2",
    style: { "line-height": "1.8rem" }
}, [
    /*#__PURE__*/ _createTextVNode(" Damit Sie Ihr Konto nutzen können, müssen Sie Ihre E-Mail-Adresse bestätigen. Geben Sie bitte dazu den "),
    /*#__PURE__*/ _createElementVNode("b", null, "Bestätigungscode"),
    /*#__PURE__*/ _createTextVNode(", welchen Sie per E-Mail erhalten haben ein. ")
], -1);
const _hoisted_11 = {
    key: 0,
    class: "mb-3 error__message-container"
};
const _hoisted_12 = { class: "mb-3" };
const _hoisted_13 = {
    key: 0,
    class: "mb-3 error__message-container"
};
const _hoisted_14 = { class: "row align-middle mt-3" };
const _hoisted_15 = { class: "col-sm-7 my-auto align-middle pr-0 d-flex justify-content-center justify-content-sm-start mb-3 mb-sm-2" };
const _hoisted_16 = { class: "col-sm-5 col-12 text-end pl-0" };
const _hoisted_17 = { class: "mb-3" };
const _hoisted_18 = ["innerHTML"];
const _hoisted_19 = { class: "row align-middle" };
const _hoisted_20 = /*#__PURE__*/ _createElementVNode("div", { class: "col-sm-7" }, null, -1);
const _hoisted_21 = { class: "col-sm-5 text-end pl-0" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_text_field = _resolveComponent("g-text-field");
    const _component_g_link = _resolveComponent("g-link");
    const _component_g_button = _resolveComponent("g-button");
    return (_ctx.internalMode == 'login')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createVNode(_component_g_text_field, {
                dataObject: _ctx.$data,
                dataMember: "userName",
                label: _ctx.$tc('account.UserNameEMail') + '*',
                mode: "email",
                "data-mode": "model",
                "show-clear-button": false,
                onEnterKey: _ctx.runLogin
            }, null, 8, ["dataObject", "label", "onEnterKey"]),
            _createVNode(_component_g_text_field, {
                dataObject: _ctx.$data,
                dataMember: "password",
                label: _ctx.$tc('account.Password') + '*',
                mode: "password",
                "data-mode": "model",
                onEnterKey: _ctx.runLogin,
                autocomplete: "on"
            }, null, 8, ["dataObject", "label", "onEnterKey"]),
            (_ctx.hasError)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.errorMessage), 1))
                : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("span", null, [
                        _createVNode(_component_g_link, {
                            onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.internalMode = 'recovery'))
                        }, {
                            default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$tc('account.ForgotPassword')), 1)
                            ]),
                            _: 1
                        })
                    ])
                ]),
                _createElementVNode("div", _hoisted_4, [
                    _createVNode(_component_g_button, {
                        text: _ctx.$tc('account.Login'),
                        "is-loading": _ctx.isLoading,
                        disabled: _ctx.disableLogin,
                        "button-style": "btn-secondary",
                        onClick: _ctx.runLogin
                    }, null, 8, ["text", "is-loading", "disabled", "onClick"])
                ])
            ])
        ], 64))
        : (_ctx.internalMode == 'activate')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createVNode(_component_g_text_field, {
                    "data-object": _ctx.$data,
                    "data-member": "codeConfirmed",
                    "data-mode": "model",
                    label: _ctx.$tc('account.ActivationCodeWithNotes'),
                    mode: "text",
                    "show-clear-button": false,
                    onEnterKey: _ctx.runActivate
                }, null, 8, ["data-object", "label", "onEnterKey"]),
                (_ctx.hasError)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.errorMessage), 1))
                    : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                        (_ctx.allowBack)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_8, [
                                _createVNode(_component_g_link, {
                                    onClick: _cache[1] || (_cache[1] = ($event) => (_ctx.internalMode = 'login'))
                                }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$tc('account.BackToLogin')), 1)
                                    ]),
                                    _: 1
                                })
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_9, [
                        _createVNode(_component_g_button, {
                            text: _ctx.$tc('account.Activation.Confirm'),
                            "is-loading": _ctx.isLoading,
                            disabled: _ctx.disableActivation,
                            "button-style": "btn-secondary",
                            onClick: _ctx.runActivate
                        }, null, 8, ["text", "is-loading", "disabled", "onClick"])
                    ])
                ])
            ], 64))
            : (_ctx.internalMode == 'activate-inline')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    _hoisted_10,
                    _createVNode(_component_g_text_field, {
                        "data-object": _ctx.$data,
                        "data-member": "codeConfirmed",
                        "data-mode": "model",
                        label: _ctx.$tc('account.ActivationCodeWithNotes'),
                        mode: "text",
                        "show-clear-button": false,
                        onEnterKey: _ctx.runActivate
                    }, null, 8, ["data-object", "label", "onEnterKey"]),
                    (_ctx.hasError)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_ctx.errorMessage), 1))
                        : _createCommentVNode("", true)
                ], 64))
                : (_ctx.internalMode == 'recovery')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                        _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$tc('account.Login.Recovery.Note')), 1),
                        _createVNode(_component_g_text_field, {
                            "data-object": _ctx.$data,
                            "data-member": "userName",
                            placeholder: "eMail-Adresse",
                            label: _ctx.$tc('account.UserNameEMail') + '*',
                            mode: "text",
                            "data-mode": "model",
                            "show-clear-button": true,
                            onEnterKey: _ctx.runRecovery
                        }, null, 8, ["data-object", "label", "onEnterKey"]),
                        (_ctx.hasError)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_ctx.errorMessage), 1))
                            : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_14, [
                            _createElementVNode("div", _hoisted_15, [
                                _createElementVNode("span", null, [
                                    _createVNode(_component_g_link, {
                                        onClick: _cache[2] || (_cache[2] = ($event) => (_ctx.internalMode = 'login'))
                                    }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$tc('account.BackToLogin')), 1)
                                        ]),
                                        _: 1
                                    })
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_16, [
                                _createVNode(_component_g_button, {
                                    text: _ctx.$tc('account.RecoveryLinkSend'),
                                    "is-loading": _ctx.isLoading,
                                    disabled: _ctx.disableRecovery,
                                    onClick: _ctx.runRecovery
                                }, null, 8, ["text", "is-loading", "disabled", "onClick"])
                            ])
                        ])
                    ], 64))
                    : (_ctx.internalMode == 'recovery-sent')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                            _createElementVNode("div", _hoisted_17, [
                                _createElementVNode("span", {
                                    innerHTML: _ctx.$tc('account.Login.Recovery.Note.Sent')
                                }, null, 8, _hoisted_18)
                            ]),
                            _createElementVNode("div", _hoisted_19, [
                                _hoisted_20,
                                _createElementVNode("div", _hoisted_21, [
                                    _createVNode(_component_g_button, {
                                        text: _ctx.$tc('account.Back'),
                                        "button-style": "btn-outline-secondary",
                                        onClick: _cache[3] || (_cache[3] = ($event) => (_ctx.internalMode = 'login'))
                                    }, null, 8, ["text"])
                                ])
                            ])
                        ], 64))
                        : _createCommentVNode("", true);
}
